'use client';

import Cta from '@/components/pages/cta';
import { AnimatedFormServer } from './server';
import { type ChangeEvent, useEffect, useRef, useState } from 'react';

export default function AnimatedFormClient({
  hideInjuryQuestions,
}: {
  hideInjuryQuestions?: boolean;
}) {
  const buttonRef = useRef<HTMLElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [hideWrapperButton, setHideWrapperButton] = useState(false);
  const [hideAll, setHideAll] = useState(false);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      const firstInput = containerRef.current?.querySelector(
        'form input'
      ) as HTMLInputElement | null;
      firstInput?.focus();
    }
  }

  useEffect(() => {
    const el = buttonRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHideWrapperButton(true);
          observer.disconnect();
        }
      },
      { threshold: 0 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <AnimatedFormServer
      ref={containerRef}
      hideWrapperButton={hideWrapperButton}
      hideAll={hideAll}
      hideInjuryQuestions={hideInjuryQuestions}
      onChange={handleChange}
      appendMessage={
        <Cta
          ref={buttonRef}
          text="Close"
          className="w-full mt-8"
          onClick={() => setHideAll(true)}
        />
      }
    />
  );
}
